var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCapacidade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#0DA9D5",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 9L18.8809 14.4111L24.6085 14.5279L20.0434 17.9889L21.7023 23.4721L17 20.2L12.2977 23.4721L13.9566 17.9889L9.39155 14.5279L15.1191 14.4111L17 9Z",
    fill: "#0DA9D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCapacidade);
export default __webpack_public_path__ + "static/media/icon-capacidade.536e9510.svg";
export { ForwardRef as ReactComponent };